import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle Stör.'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Stör.)'},
  {key: FILTER_NONE, label: 'Keine Stör.'},
];
